'use client';

import { c as _c } from "react/compiler-runtime";
import { type FieldValues, FormProvider } from 'react-hook-form';
import ActionFormContext from '../ActionFormContext';
import type { ActionFormProviderProps } from './types';
function ActionFormProvider(t0) {
  const $ = _c(16);
  let children;
  let defaultValues;
  let props;
  let setBusy;
  let submit;
  if ($[0] !== t0) {
    ({
      children,
      setBusy,
      submit,
      defaultValues,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = defaultValues;
    $[3] = props;
    $[4] = setBusy;
    $[5] = submit;
  } else {
    children = $[1];
    defaultValues = $[2];
    props = $[3];
    setBusy = $[4];
    submit = $[5];
  }
  let t1;
  if ($[6] !== defaultValues || $[7] !== setBusy || $[8] !== submit) {
    t1 = {
      setBusy,
      submit,
      defaultValues
    };
    $[6] = defaultValues;
    $[7] = setBusy;
    $[8] = submit;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== children || $[11] !== props) {
    t2 = <FormProvider {...props}>{children}</FormProvider>;
    $[10] = children;
    $[11] = props;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = <ActionFormContext.Provider value={t1}>{t2}</ActionFormContext.Provider>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
export default ActionFormProvider;